<template lang="pug">
UiSelect(
  @update:modelValue="$emit('update:modelValue', $event)"
  :modelValue="modelValue"
  :options="getData"
  :object="object"
  :searchable="false"
)
</template>

<script>
import ApiCompanyDimensionNames from "@/api/company_dimension_names.js";

export default {
  emits: ["update:modelValue"],

  props: {
    modelValue: {
      default: null,
    },
    object: {
      default: false,
    },
    companyId: {
      required: true,
    },
  },
  methods: {
    async getData() {
      const response = await ApiCompanyDimensionNames.fetchAll(this.companyId);

      return {
        items: response?.data?.dimension_names?.map(({ id, name }) => ({
          label: name,
          value: id,
        })),
      };
    },
  },
};
</script>
